import React from 'react'
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import Grid from '@mui/material/Grid';
import { Skeleton } from '@mui/material';
interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  subsGrowthStockChartData: any;
  loader: boolean;
}
const ContentTypeChart: React.FC<Props> = (props: Props) => {
// Step 1: Get all unique months and paid types
const shortMonth = (str: string) => {
  const [month, year] = str.split(" ");
  return `${month.slice(0, 3)} ${year.slice(-2)}`;
};

const categories = [...new Set(props.subsGrowthStockChartData.map((item: any) => shortMonth(item.month_year)))];
const paidTypes = [...new Set(props.subsGrowthStockChartData.map((item: any) => item.paid_type))];

const formattedLabels:any = {
  brand: "Brand",
  brand_organic: "Organic/Tagged",
  paid: "Paid"
};
const colorMap: { [key: string]: string } = {
  brand: '#34E39A',      // Yellow
  brand_organic: '#D379F0', // Green
  paid: '#288CFF',         // Blue
};

const series = paidTypes.map((paid_type:any) => ({
  name: formattedLabels[paid_type] || paid_type,
  color: colorMap[paid_type] || '#999',
  data: categories.map(month =>
    props.subsGrowthStockChartData.find((item: any) => shortMonth(item.month_year) === month && item.paid_type === paid_type)?.distinct_shortcode_count || 0
  )
}));


// Step 3: Highcharts options
const chartOptions = {
  chart: {
    type: 'column',
    height: 230
    
  },
  title: {
    text: null // Disables the chart title
  },
  xAxis: {
    categories: categories,
    crosshair: true,
    title: {
      text: 'Month'
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: 'No. of Posts'
    }
  },
  tooltip: {
    shared: true,
    useHTML: true,
    shadow: false,
    formatter: function (this: any) {
      let header = `<div class="tooltip-box"><strong style="padding-bottom: 10px; display:block; font-size: 18px;">No. of Posts</strong>`;
      let body = this.points?.map((point: any) =>
        `<div class="tooltip-content-box">
          <span style="color:${point.color}; margin-right:10px; display:inline-flex;">\u25CF</span>
          <span class="tooltip-content-box-value">${point.series.name}: <b>${point.y}</b></span>
        </div>`
      ).join('');
      return header + body + `</div>`;
    },  
    style: {
      boxShadow: 'none',
    }
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: series,
  exporting: {
    enabled: false
  },
  credits: {
    enabled: false
  }
  
};


  return (
    <>
      {props?.loader ? <Skeleton variant="rectangular" height={'100%'} style={{borderRadius:'6px'}} /> : 
      <section className="brand-insight-highchart ">
        <div className="brand-insight-highchart-top">
          <strong className="brand-insight-highchart-title">Content Type</strong>
        </div>
        <div className="brand-insight-highchart-data">
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
          />
        </div>
      </section>
    }
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(ContentTypeChart);

export { connectToRedux as ContentTypeChart };